module.exports = __webpack_public_path__ + "img/quit.20f3bf0a.svg";